import {
  BORDER_STYLES,
  CAPTION_STYLES,
  COMMON_STYLES,
  DefaultProductImage,
  formatCurrency,
  LazyImage,
  PARAGRAPH_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'
import { OrderDetail } from 'app/farmer360/models/orderDetails'
import React from 'react'
import { Image, ImageSourcePropType, Text, View } from 'react-native'

interface Props {
  productList: OrderDetail[]
}

const OrderProducts = ({ productList }: Props) => {
  return (
    <View style={[{ borderBottomWidth: 1 }, BORDER_STYLES.borderNeutral20]}>
      <Text
        style={[
          TYPOGRAPHY.HEADING3,
          VARIANTS_STYLES.EMPHASIZED,
          TEXT_STYLES.textNeutral90,
        ]}
      >
        Item Detail
      </Text>
      {productList?.map(
        (
          {
            id,
            product_name,
            product,
            price,
            discount,
            quantity,
            variant_attributes,
            product_brand_name,
          },
          index,
        ) => {
          return (
            <View
              key={id}
              style={[
                COMMON_STYLES.row,
                COMMON_STYLES.pb1,
                index !== productList.length - 1 && COMMON_STYLES.divider,
                index > 0 && COMMON_STYLES.pt1,
              ]}
            >
              <LazyImage
                imgStyles={[COMMON_STYLES['p1/2'], { height: 80, width: 80 }]}
                imageUrl={product.image_url}
                fallBackIcon={
                  <Image
                    source={DefaultProductImage as ImageSourcePropType}
                    style={[COMMON_STYLES['p1/2'], { height: 80, width: 80 }]}
                  />
                }
              />
              <View style={[COMMON_STYLES.pl1, COMMON_STYLES.flex1]}>
                {product_brand_name ? (
                  <Text
                    style={[
                      CAPTION_STYLES.MEDIUM_C1,
                      TEXT_STYLES.textNeutral40,
                    ]}
                  >
                    {product_brand_name}
                  </Text>
                ) : null}
                {product_name ? (
                  <Text
                    style={[
                      PARAGRAPH_STYLES.MediumT1,
                      TEXT_STYLES.textNeutral90,
                    ]}
                  >
                    {product_name}
                  </Text>
                ) : null}
                <View
                  style={[COMMON_STYLES.row, COMMON_STYLES.alignItemsCenter]}
                >
                  <Text
                    style={[
                      CAPTION_STYLES.MEDIUM_C1,
                      TEXT_STYLES.textNeutral90,
                    ]}
                  >
                    {`${variant_attributes.attribute_value[0].name} x ${quantity}`}
                  </Text>
                  <Text
                    style={[
                      PARAGRAPH_STYLES.MediumT1,
                      TEXT_STYLES.textNeutral80,
                    ]}
                  >
                    {` | ${formatCurrency(Number(price) - Number(discount))}`}
                  </Text>
                </View>
              </View>
            </View>
          )
        },
      )}
    </View>
  )
}

export default OrderProducts
